<script lang="ts" setup>
import type {
  EventMergeRecord,
  MutationsMerger,
} from '@gmao/shared';
import type { MutationTypes } from '@gmao/types';
import type { Component } from 'vue';
import {
  EventCounter,
  EventMachineStatus,
  EventMaintenance,
  EventMoveModule,
  EventResetOverdue,
} from '@gmao/shared';
import { computed } from 'vue';

const props = defineProps<{
  event: EventMergeRecord;
  events: EventMergeRecord[];
  merger: MutationsMerger;
}>();

const components: Record<MutationTypes, Component | undefined> = {
  maintenance: EventMaintenance,
  move: EventMoveModule,
  counter: EventCounter,
  machineStatus: EventMachineStatus,
  resetOverdue: EventResetOverdue,
  stock: undefined, // No display for merger (included in maintenance logs)
};

const is = computed(() => components[props.event.type]);
</script>

<template>
  <component
    :is="is"
    v-if="is"
    :event="event"
    :events="events"
    :merger="merger"
  />
</template>
